module.exports = __webpack_public_path__ + "img/result_ceil_lx_angle.4708d463.jpg";